export default __webpack_public_path__ + "static/media/certificates-profile-inact.714c7b90.svg";